import FocusedCardComponent from './FocusedCardComponent';
export default FocusedCardComponent;
